import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

export const ActiveCardInputsStyled = styled(Stack)(({ theme }) => ({
  padding: '24px',
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: '22px'
}));

export const Wrapper = styled(Stack)(({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
}));
